var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextDivider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1174.000000pt",
    height: "58.000000pt",
    viewBox: "0 0 1174.000000 58.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,58.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5835 386 c-134 -58 -49 -261 86 -205 87 36 90 162 5 203 -40 19 -51 19 -91 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5225 335 c-60 -25 -114 -46 -119 -48 -6 -2 48 -26 120 -54 l129 -51 50 20 c28 11 69 27 92 36 l43 16 35 -34 35 -34 50 50 50 49 -50 50 -50 49 -36 -36 -36 -36 -84 34 c-46 19 -92 34 -101 33 -10 0 -67 -20 -128 -44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6097 332 l-47 -48 50 -49 50 -49 35 34 35 34 43 -16 c23 -9 65 -25 92 -36 l50 -20 124 49 c68 27 126 50 127 52 5 5 -238 97 -254 97 -7 0 -50 -15 -96 -34 l-84 -34 -33 34 c-18 19 -36 34 -39 34 -3 0 -27 -22 -53 -48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2950 310 c-1123 -8 -1740 -18 -1740 -30 0 -4 134 -10 298 -14 270 -6 2589 -25 3185 -26 l247 0 0 40 0 40 -477 -2 c-263 -1 -944 -5 -1513 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6820 280 l0 -42 1108 7 c1204 6 2613 23 2621 30 2 3 2 7 0 10 -8 7 -1417 24 -2621 30 l-1108 7 0 -42z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextDivider);
export default __webpack_public_path__ + "static/media/text-divider.118829d9.svg";
export { ForwardRef as ReactComponent };